module.exports = __webpack_public_path__ + "cd7480fe54e239abc4ce3c3c88cab838.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/fox-ears.png
// module id = 2675
// module chunks = 0